import * as React from "react";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import "./deleteproduct.scss";
import ClearIcon from "@mui/icons-material/Clear";
import { DELETE_PRODUCT } from "../../Schema/product";
import { useMutation } from "@apollo/client";

function DeleteProduct({
  handleCloseDel,
  Data,
  refetch,
  setAlert,
  setMessage,
  setchekMessage,
}) {
  const [valueVoid, setValueVoid] = React.useState("");
  const [deleteProduct] = useMutation(DELETE_PRODUCT, {
    onCompleted:({ deleteProduct }) => {

      if (deleteProduct?.status) {
        setchekMessage("success");
        setMessage(deleteProduct?.message);
        setAlert(true);
        refetch();
        handleCloseDel();

      } else {
        setchekMessage("error");
        setMessage(deleteProduct?.message);
        setAlert(true);
      }
    },

      onError: ({ error }) => {
        setchekMessage("error");
        setMessage(error.message);
      },
  });

  const handleDelete = () => {
    deleteProduct({
      variables: {
        productId: Data?._id,
      },
    });
  };

  return (
    <Box className="delete-product">
      <Stack direction="row" spacing={5}>
        <Typography className="title" variant="h6">
          DELETE PRODUCT
        </Typography>
        <Box sx={{ flexGrow: 1 }}></Box>
        <IconButton onClick={() => handleCloseDel()}>
          <ClearIcon sx={{ color: "red" }} />
        </IconButton>
      </Stack>

      <Stack direction="row" spacing={5} width="100%">
        <Typography variant="subtitle1" className="simple-text">
          Do you want to delete ?
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        spacing={1}
        width="100%"
        sx={{ mt: 2 }}
      >
        <Typography variant="subtitle1" className="simple-text" >
          Please input
        </Typography>
        <Typography className="body-text" variant="subtitle1">
          PRODUCT
        </Typography>
        <Typography variant="subtitle1" className="simple-text">
          to delete
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        spacing={1}
        width="100%"
        sx={{ mb: 3 }}
      >
        <TextField
          className="text-input"
          size="small"
          fullWidth
          onChange={(e) => setValueVoid(e.target.value)}
        />
      </Stack>
      
      <Stack direction="row" spacing={5}>
        {valueVoid === "PRODUCT" ? (
          <Button
            onClick={handleDelete}
            sx={{ ":hover": { backgroundColor: "red", border: "none" } }}
            className="btn-void"
            variant="outlined"
            fullWidth
          >
            DELETE NOW
          </Button>
        ) : (
          <Button variant="outlined" className="btn-delete" fullWidth>
            DELETE
          </Button>
        )}
      </Stack>

    </Box>
  );
}

export default DeleteProduct;
